// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Iv-z","tooltipWrapper":"Jv-z","icon":"Kv-z","tooltip":"Lv-z","content":"Mv-z"};